import type {
  BulkDeleteTransactionNotesApiResponse,
  CreateTransactionNoteRequest,
  DeleteBulkTransactionNotesRequest,
  TransactionNote,
  UpdateTransactionNoteRequest,
} from '@/types/transaction-note';

/**
 * Demo-mode fabricated response for adding a transaction note.
 * Used as the demoFn for useAddTransactionNote.
 */
export function addTransactionNoteDemoResponse(
  request: CreateTransactionNoteRequest & { userId: string; userName: string },
): TransactionNote {
  return {
    id: String(Date.now()),
    transactionId: String(request.transactionId),
    content: request.content,
    createdAt: new Date().toISOString(),
    createdBy: {
      id: request.userId,
      name: request.userName,
    },
  };
}

/**
 * Demo-mode fabricated response for editing a transaction note.
 * Used as the demoFn for useUpdateTransactionNote.
 */
export function updateTransactionNoteDemoResponse(request: UpdateTransactionNoteRequest): TransactionNote {
  return {
    id: request.noteId,
    transactionId: String(request.transactionId),
    content: request.content,
    createdAt: new Date().toISOString(),
    createdBy: {
      id: '',
      name: 'Current User',
    },
  };
}

/**
 * Demo-mode fabricated response for deleting transaction notes in bulk.
 * Used as the demoFn for useDeleteBulkTransactionNotes.
 */
export function deleteBulkTransactionNotesDemoResponse(
  request: DeleteBulkTransactionNotesRequest,
): BulkDeleteTransactionNotesApiResponse {
  return {
    deletedCount: request.noteIds.length,
    failedNoteIds: [],
  };
}
